// LivePopupBanner — rotating admin-managed activity popups on Marketplace.
// Displays 1 popup at a time, rotates every 4s with a blinking pulse animation.
// Falls back gracefully if none configured.
import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const FALLBACK = [
  { id: 'f1', text: 'Rakesh ne abhi ek order kiya — Electronics', icon: '🎉', tint: 'from-emerald-500 to-teal-600' },
  { id: 'f2', text: 'Sapna ko 10% offer mila — Fashion', icon: '💝', tint: 'from-pink-500 to-rose-600' },
  { id: 'f3', text: 'Amit ka parcel deliver ho gaya', icon: '📦', tint: 'from-amber-500 to-yellow-600' },
];

export default function LivePopupBanner() {
  const [popups, setPopups] = useState([]);
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    api.get('/marketplace/popups/active').then((r) => {
      const rows = r.data?.popups || [];
      setPopups(rows.length ? rows : FALLBACK);
    }).catch(() => setPopups(FALLBACK));
  }, []);

  useEffect(() => {
    if (popups.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % popups.length), 4200);
    return () => clearInterval(t);
  }, [popups.length]);

  if (!visible || popups.length === 0) return null;
  const p = popups[idx];

  return (
    <div className="fixed bottom-16 left-2 z-40 max-w-xs animate-fade-in" data-testid="mkt-live-popup">
      <div className={`relative rounded-full pl-2 pr-7 py-2 shadow-2xl bg-gradient-to-r ${p.tint || 'from-emerald-500 to-teal-600'} text-white text-xs font-black flex items-center gap-2 border border-white/40`}
           style={{ animation: 'popup-blink 1.4s ease-in-out infinite' }}>
        <span className="text-lg leading-none animate-bounce" style={{ animationDuration: '1s' }}>{p.icon || '🎉'}</span>
        <span className="truncate">{p.text}</span>
        <button onClick={() => setVisible(false)} data-testid="mkt-live-popup-close"
                className="absolute top-1 right-1 w-5 h-5 rounded-full bg-black/40 text-white text-[10px] font-black">✕</button>
        <span className="absolute inset-0 rounded-full ring-2 ring-white/60 pointer-events-none" style={{ animation: 'popup-ring 1.4s ease-in-out infinite' }} />
      </div>
      <style>{`
        @keyframes popup-blink {
          0%, 100% { transform: scale(1); box-shadow: 0 8px 30px -4px rgba(0,0,0,0.4); }
          50% { transform: scale(1.03); box-shadow: 0 12px 40px -4px rgba(0,255,180,0.6); }
        }
        @keyframes popup-ring {
          0%, 100% { opacity: 0.6; transform: scale(1); }
          50% { opacity: 0; transform: scale(1.15); }
        }
        @keyframes fade-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in { animation: fade-in .35s ease-out; }
      `}</style>
    </div>
  );
}
